import { Injectable } from '@angular/core'
import { ODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IRaw837FileExport extends IModelBase {
  ExportedBy: string
  ExportDate: Date
  ClaimTypeId: string
  ExportType: string
  PayerId: string
  JointVentureName: string
  EnvelopId: number
  FunctionalGroupId: number
  TransactionSetId: number
}

@Injectable()
export class Raw837FileExportODataService extends ODataService<IRaw837FileExport> {
  constructor(
    protected http: HttpClient,
    protected config: ODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'Raw837FileExports'
  }
}
